module.exports = __webpack_public_path__ + "static/media/03.40c3e543.png";